import { useState } from "react";
import { createGenericContext } from "../../utils/createGenericContext";

export interface IFormProgressContext {
  // True only while the patient is actually answering a form. The preparation wizard and the
  // post-submission confirmation both live under the same /forms route but have nothing to lose, so
  // the header cannot decide this from the url alone - the form screen reports it.
  formInProgress: boolean;
  setFormInProgress: (inProgress: boolean) => void;
}

const [useFormProgress, FormProgressContextProvider] =
  createGenericContext<IFormProgressContext>();

const FormProgressProvider = (props: any) => {
  const [formInProgress, setFormInProgress] = useState(false);

  return (
    <FormProgressContextProvider value={{ formInProgress, setFormInProgress }}>
      {props.children}
    </FormProgressContextProvider>
  );
};

export { FormProgressProvider, useFormProgress };
